/**
 * Created by Qingger Corp.
 * User:
 * Date: 2019/9/18
 * Time: 19:44
 * Desc: 营销中心-秒杀活动-新增/编辑
 */
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import type { ElForm } from "element-ui/types/form";
import cloneDeep from "lodash/cloneDeep";
import moment from "moment";
import { groupBy } from "lodash";
import { client } from "rsui-core/lib/post-message";
import { ElCarousel } from "element-ui/types/carousel";
import { appEnvConfig } from "@/configs/appConfigs";
import { EmpServiceAPIActions } from "@/services/empService";
import { IPSService } from "@/services/ipsServices";
import IPSDatePicker from "@/views/components/ips-date-picker";
import Sketch from "@/views/components/sketch";
import selectGoods from "@/views/components/selectGoods";
import ProductItem from "@/views/components/productItem/productItem.vue";
import Upload from "@/views/components/upload/upload.vue";
import ImgPreview from "@/views/components/imgPreview";
import baseAPIService from "@/services/base/baseAPIService";
import importBatchSet from "@/views/components/importBatchSet";
import { flatten, noop } from "@/util";
import { Functions } from "@/library/utils/functions";
import productItem from "@/views/components/productItem/productItem";
import AddPrimarySite from "@/views/components/addSite";
import NewSelectSite from "@/views/components/newSelectSIte";

interface skuItem {
	sku: string;
	specVal: string; // 规格
	originPrice: number; // 牌价
	price: number; // 秒杀价
	saleNum: string; // 销量
	stock: string; // 总库存
}
interface productItemObj {
	skId: number; // 秒杀ID
	productName: string; // 商品名称
	productCode: string; // 商品货号
	productImage: string; // 商品图片
	maxBuyerNum: number; // 本套餐最多购买量 0表示不限制
	minBuyerNum: number; // 本套餐最多购买量 0表示不限制
	isMustBuy: number; // 是否是必选商品 0不是 1是
	isDefault: number; // 是否默认选中 0不是 1是
	skuItems: skuItem[];
	sort: number; // 排序
}
interface buyConfigObj {
	type: number; // 0不限制 1限制金额
	num: number; // 满多少元可下单
	tipShow: number; // 限制在顾客下单时展示金额限制提示语
}
interface receiptConfigObj {
	type: number; // 0所有会员均可参与 1指定参与条件
	id: string; // 指定参与条件中的会员参与ID
	note: string; // 不满足条件的提示信息
}
interface siteItemObj {
	siteId: number | string;
	siteCode: number | string;
}
interface dispalyConfigObj {
	displayType?: number; // 价格展示 1展示已选商品总价 2以A+B+C方式1展示已选商品价格
	isCountdown: number; // 秒杀倒计时 0不展示 1展示
	tagName: string; // 标签文字
	tagBackPic: string; // 价签底图
}
interface ISecKillGroupForm {
	skgId?: string | number;
	skgName?: string;
	siteCodes?: string[];
	siteIds?: string[];
	siteList?: siteItemObj[];
	beforeBeginTime?: string | number;
	actBeginTime?: string | number;
	actEndTime?: string | number;
	productList?: productItemObj[];
	buyConfig?: buyConfigObj;
	isCanReturnGoods?: number; // 是否支持退货 0不支持 1支持
	receiptConfig?: receiptConfigObj;
	displayConfig?: dispalyConfigObj;
	imageList?: string[];
	state?: number | string;
	activityState?: number | string;
	shareCardPicture?: string;
	sharePicture?: string;
	actImage?: string;
	qikanImage?: string;
	shippingState?: number;
	operAuthority?: number;
	isOpenCommission?: number;
	_qikanShow?: boolean;
	_actShow?: boolean;
	buttonName?: string;
	_limit?: number; // 限制大于或大于等于的金额，对应buyerConfig.type type=0 不限制 1大于等于 2 等于
	pointsType?: number;
}

@Component({
	components: {
		IPSDatePicker,
		Sketch,
		ProductItem,
		Upload,
	},
})
export default class seckillGroupEdit extends Vue {
	$refs: {
		Sketch: Sketch;
		secKillForm: ElForm;
		productItem: ProductItem;
	};

	excelHeader = [
		{ header: "货号", key: "productCode", width: 15 },
		{ header: "条码", key: "sku", width: 20 },
		{ header: "规格", key: "specVal", width: 10 },
		{ header: "秒杀价(元)", key: "price", width: 40 },
		{ header: "库存", key: "stock", width: 40 },
	];

	//  预览组件的参数

	componentKeys = ["seckillGroup", "shareCard", "sharePoster"];

	get componentData() {
		return [this.seckillForm.productList, { img: this.seckillForm.shareCardPicture, title: this.seckillForm.skgName }, { img: this.seckillForm.sharePicture, title: this.seckillForm.skgName }];
	}
	//   0已下架  1未开始 2预热期 3秒杀中 4已结束
	// a. 预热开始前，所有内容均可修改；
	// b. 预热开始后，【预热开始时间】、【活动商品】不可再修改；
	// c. 秒杀开始后，【预热开始时间】、【秒杀开始时间】、【活动商品】、所有【购买规则】不可修改，其他均可修改；
	// d. 秒杀结束后，所有内容均不可修改；
	// 时间活动商品只能在预热开始前修改
	get timeState() {
		return this.isCopy ? false : (this.$route.params.id !== "0" && this.seckillForm.activityState !== 1) || !this.operAuthority;
	}
	// 秒杀开始时间\购买规则\预热\活动商品在未开始和预热期可以修改
	get otherState() {
		return this.isCopy ? false : (this.$route.params.id !== "0" && this.seckillForm.activityState !== 1 && this.seckillForm.activityState !== 2) || !this.operAuthority;
	}
	get disabledState() {
		return this.isCopy ? false : (this.$route.params.id !== "0" && (this.seckillForm.activityState === 4 || this.seckillForm.activityState === 0)) || !this.operAuthority;
	}

	get stockDisabledState() {
		return this.isCopy ? true : (this.$route.params.id !== "0" && (this.seckillForm.activityState === 4 || this.seckillForm.activityState === 0)) || !this.operAuthority;
	}

	/**
	 * 秒杀活动Id
	 * @type {number}
	 */
	@Prop({ default: 0 }) skId: number;

	/**
	 * 图片上传地址
	 * @type {string}
	 */
	public fileTpConfig = `${Functions.ipsHostUrlApi()}/pic/upload/withOut/key`;

	/**
	 * token
	 * @type {{Authorization: string}}
	 */
	public tokenData: ItemObject = {
		Authorization: `Bearer ${EmpServiceAPIActions.getTokenFromCache().token}`,
	};

	public condition: any = {
		id: "",
		text: "",
	};

	public isOpenSkCart = 0;
	public radio: Boolean = false;
	public siteIds: Array<number> = [];
	public btnLoading: Boolean = false;

	public platformVersion: number = null;

	public option = [
		{ label: "大于等于", value: 1 },
		{ label: "等于", value: 2 },
	];

	// 是否是复制的秒杀组活动 1是 0否

	public isCopy = 0;
	/**
	 * 根据筛选条件
	 */
	setCondition(e) {
		if (this.seckillForm.siteCodes.length) {
			const siteId = +localStorage.getItem("siteId") || +localStorage.getItem("firstSiteId");
			e.stopPropagation();
			const protocol = `${location.protocol}//`;
			let hostName = location.hostname;
			hostName.includes("host") && (hostName = "ips.maintenance.qingger.cn");

			IPSService.siteGroupConfig({
				postParams: {
					siteId,
					sgId: +this.$route.params.sgId || +this.$route.params.id,
				},
			}).then((res) => {
				client
					.pick({
						path: "customer-predicate",
						dialogStyle: { width: "50vw", height: "100vh", backgroudColor: "#eee", zIndex: 99999999999 },
						modelDialog: true,
						slide: "left",
						props: {
							params: { actId: res.actId || 2 },
							zIndex: 99999999999,
							id: this.condition.id,
							exclude: ["#root.crmPublicAccounts"],
						},
						domain: `${protocol + hostName}/scrm/web`,
						cancel: true,
						search: `?baseURL=/nips/scrm&ext_ips__auth_token=${this.tokenData.Authorization}&ext_ips__site=${siteId}`,
					})
					.then((r: any) => {
						this.condition = r;
						this.seckillForm.receiptConfig.id = this.condition.id ? this.condition.id : "";
					});
			});
		} else {
			this.$message.warning("请先选择网点");
		}
	}

	getConditionText() {
		if (!this.condition.id) {
			return;
		}
		IPSService.customerCondition({
			queryParams: {
				id: this.condition.id,
				EXT_IPS__SITE: this.seckillForm.siteIds[0] ? this.seckillForm.siteIds[0] : "",
			},
		}).then((response) => {
			let length = 0;
			(response.conditions || []).forEach((val) => {
				const orLength = val.or ? val.or.length : 0;
				const andLength = val.and ? val.and.length : 0;
				length = length + orLength + andLength;
			});
			this.condition.text = `已选择${length}个条件`;
		});
	}

	/**
	 * 清空限制条件
	 */
	closeCondition() {
		this.condition.id = "";
		this.condition.text = "";
		this.seckillForm.receiptConfig.id = "";
	}

	/**
	 * 切换参与门槛
	 */
	changeReceiptConfig() {
		if (this.seckillForm.receiptConfig.type == 0) {
			this.closeCondition();
		}
	}

	/**
	 *
	 * 切换限制金额
	 */
	changebuyConfig() {
		if (!this.seckillForm.buyConfig.type) {
			this.seckillForm.buyConfig.num = null;
		}
	}

	/**
	 * 图片放大弹窗是否显示
	 * @type {boolean}
	 */
	public isMagnifyPopShow = false;

	/* 图片上传地址 */
	public imgTpConfig = `${Functions.ipsHostUrlApi()}/pic/upload/withOut/key`;

	/**
	 * corpId
	 */
	public corpId = baseAPIService.resolveCorpId();

	public siteId = 0;

	/**
	 * 添加活动列表
	 * @type {ItemObject}
	 */
	public seckillForm: ISecKillGroupForm = {
		skgId: 0,
		skgName: "",
		siteCodes: [],
		beforeBeginTime: "",
		actBeginTime: "",
		actEndTime: "",
		productList: [],
		buyConfig: {
			type: 0,
			num: null,
			tipShow: 0,
		},
		receiptConfig: {
			type: 0,
			id: null,
			note: "您暂时无法参与本秒杀",
		},
		displayConfig: {
			isCountdown: 1,
			displayType: 1,
			tagName: "秒杀组价",
			tagBackPic: "https://ssl-picture.tenyun.runsasoft.com/17c653c021ee11edbc6f9f0cd6b88bcb.png",
		},
		buttonName: "立即秒杀",
		isCanReturnGoods: 1,
		imageList: [],
		state: null,
		activityState: null,
		shareCardPicture: "",
		sharePicture: "",
		actImage: "",
		qikanImage: "",
		pointsType: 1,
		shippingState: 0,
		isOpenCommission: 0,
	};

	public rules = {
		skgName: [{ required: true, message: "请输入秒杀活动名称", trigger: "change" }],
		buttonName: [{ required: true, message: "请输入秒杀按钮文字", trigger: "change" }],
		siteCodes: [{ required: true, message: "请选择适用网点", trigger: ["change", "blur"] }],
		beforeBeginTime: [{ required: true, message: "请选择预热开始时间", trigger: "change" }],
		actBeginTime: [{ validator: this.VActBeginTime, trigger: "change" }],
		actEndTime: [{ validator: this.VActEndTime, trigger: "change" }],
		remindTime: [{ required: true, message: "请输入秒杀开始前时间", trigger: "change" }],
		productList: [{ required: true, message: "请添加活动商品", trigger: ["change", "blur"] }],
		imageList: [{ required: true, message: "请选择秒杀图片", trigger: "change" }],
		shareCardPicture: [{ required: true, message: "请选择分享卡片封面", trigger: "change" }],
		sharePicture: [{ required: true, message: "请选择分享海报封面", trigger: "change" }],
		"receiptConfig.note": [{ required: true, message: "请输入无法参与用户提示", trigger: "change" }],
		"receiptConfig.id": [{ required: true, message: "请选择限制条件", trigger: "change" }],
		"buyConfig.num": [{ required: true, message: "请输入限制金额", trigger: "change" }],
		"displayConfig.tagName": [{ required: true, message: "请输入价签文字", trigger: "change" }],
	};

	VActBeginTime(rule, value, callback) {
		const remindTime = moment(this.seckillForm.beforeBeginTime).unix();
		if (!value) {
			callback(new Error("请选择秒杀活动开始时间"));
		} else if (moment(value).unix() <= remindTime || moment(this.seckillForm.actBeginTime).unix() <= remindTime) {
			callback(new Error("活动开始时间需大于预热开始时间"));
		} else if (this.seckillForm.actEndTime && moment(value).unix() > moment(this.seckillForm.actEndTime).unix()) {
			callback(new Error("活动开始时间不能大于活动结束时间"));
		} else {
			callback();
		}
	}
	VActEndTime(rule, value, callback) {
		const remindTime = moment(this.seckillForm.beforeBeginTime).unix();
		if (!value) {
			callback(new Error("请选择秒杀活动结束时间"));
		} else if (moment(value).unix() <= remindTime || moment(this.seckillForm.actEndTime).unix() <= remindTime) {
			callback(new Error("活动结束时间需大于预热开始时间"));
		} else if (this.seckillForm.actBeginTime && moment(value).unix() <= moment(this.seckillForm.actBeginTime).unix()) {
			callback(new Error("活动结束时间不能小于活动开始时间"));
		} else {
			callback();
		}
	}
	openSelectSiteDialog(code) {
		// 沈总说换成单网点选择
		new NewSelectSite()
			.open({
				sgId: +this.$route.params.sgId || +this.$route.params.id,
				selectCodes: this.seckillForm.siteCodes,
				readonly: !code,
			})
			.then((val: string[]) => {
				if (val.length > 1) {
					this.$message.error("秒杀组只能选择单网点");
					return;
				}
				this.seckillForm.siteCodes = val;
			}, noop);
	}

	/**
	 * 时间选择控制
	 * @return null
	 * @desc 当前时间控制到今天
	 */
	public pickerOptions: ItemObject = {
		disabledDate(time) {
			return time.getTime() < new Date(new Date().toLocaleDateString()).getTime();
		},
	};
	/**
	 * 时间选择控制
	 * @return null
	 * @desc 当前时间控制到今天
	 */
	public pickerToOptions: ItemObject = {
		disabledDate(time) {
			return time.getTime() < new Date(new Date().toLocaleDateString()).getTime();
		},
	};
	/**
	 * 错误图片
	 */
	public errorImg: any = require("../../../../static/img/bg_pic.png");

	// 选择商品的类型
	public selectGoodsType: 1 | 2 = 1;

	// 传给预览的参数
	public goodsInfo = null;

	// 是否有权限 1 有权限0 没有
	public operAuthority = 1;

	/* 方法 */

	public uploadActivityPicSuccess(res: any): void {
		this.seckillForm.imageList = res;
	}

	public uploadPricePic(res: any): void {
		this.seckillForm.displayConfig.tagBackPic = res;
	}

	public uploadShareCardPictureSuccess(res: any): void {
		this.seckillForm.shareCardPicture = res.content;
		this.seckillForm.actImage = res.content;
	}

	public uploadSharePictureSuccess(res: any): void {
		this.seckillForm.sharePicture = res.content;
		this.seckillForm.qikanImage = res.content;
	}

	/**
	 * 图片上传失败
	 * @return null
	 */
	public uploadImgError(): void {
		this.$message.error("图片上传失败");
	}

	/**
	 * 图片上传之前
	 * @param {ItemObject} file
	 * @return boolean
	 */
	public onBeforeUpload(file: ItemObject): boolean {
		const isJpg = file.type === "image/jpeg";
		const isPng = file.type === "image/png";
		const isGif = file.type === "image/gif";
		const LtSize = file.size / 1024 <= 1024;
		if (!isJpg && !isPng && !isGif) {
			this.$message.error("上传图片只能是 JPG/JPEG/PNG/GIF 格式!");
		}
		if (!LtSize) {
			this.$message.error("上传图片大小不能超过 1M!");
		}
		return (isJpg || isPng || isGif) && LtSize;
	}

	/**
	 * 获取秒杀活动详情
	 * @return null
	 */
	public getSecKillDetail(): void {
		const postParams = {
			skgId: Number.parseInt(this.$route.params.id),
		};
		IPSService.secKillGroupInfo({ postParams }).then((res: any) => {
			const resp = res;
			this.operAuthority = res.operAuthority;
			if (this.isCopy) {
				resp.beforeBeginTime = "";
				resp.actBeginTime = "";
				resp.actEndTime = "";
			} else {
				resp.beforeBeginTime = moment(resp.beforeBeginTime * 1000);
				resp.actBeginTime = moment(resp.actBeginTime * 1000);
				resp.actEndTime = moment(resp.actEndTime * 1000);
			}
			resp._actShow = !!res.actImage;
			resp._qikanShow = !!res.qikanImage;
			if (res.buyConfig.type !== 0) {
				// 先判断是不是限制，是限制，将限制内容赋值给自定参数
				resp._limit = res.buyConfig.type;
				if (res.buyConfig.type === 2) {
					// 等于2时为等于，显示为限制，故重新赋值
					resp.buyConfig.type = 1;
				}
			}

			resp.siteCodes = [];
			resp.siteIds = [];

			resp.siteList.forEach((v) => {
				resp.siteCodes.push(v.siteCode);
				resp.siteIds.push(v.siteId);
			});
			this.seckillForm = resp;
			this.siteId = resp.siteList[0].siteId;
			this.isCopy && this.getStock(resp.productList);
			if (resp.receiptConfig.type == 1 && resp.receiptConfig.id) {
				this.condition.id = resp.receiptConfig.id;
				this.getConditionText();
			}

			this.$nextTick(() => {
				this.$refs.Sketch.$forceUpdate();
			});
		});
	}
	// 商品库存选择

	public getStock(list = []) {
		if (list && list.length) {
			const code = list.map((i) => i.productCode);
			const postParams = { productCodes: code, siteCode: this.seckillForm.siteCodes[0] };
			IPSService.searchProductList({ postParams })
				.then((result: any) => {
					const ylist: productItemObj[] = list.map((i) => {
						i.skuItems.map((v) => {
							result.list.map((it) => {
								it.skuItems.forEach((item) => {
									if (item.goodsSku === v.sku) {
										v.stock = item.stock;
									}
								});
								return it;
							});
							return v;
						});
						return i;
					});
					this.seckillForm.productList.concat(ylist);
					console.log("after", this.seckillForm.productList);
				})
				.catch((error) => {
					console.log(error);
					// this.$message.error("请先选择网点！");
				});
		}
	}

	/**
	 * 获取商品信息
	 * @return null
	 */
	public onGetProductInfo(): void {
		if (!this.seckillForm.siteCodes) {
			this.$message.warning("请先选择网点！");
			return;
		}
		selectGoods.open({ showBD: false, multiple: false, title: "添加商品" }).then((res) => {
			this.selectGoodsType = res.type;
			let err = 0;
			if (res.list.length > 0) {
				this.seckillForm.productList.forEach((el) => {
					if (el.productCode == res.list[0]["productCode"]) {
						err = 1;
					}
				});
			}
			if (err == 0) {
				this.seckillForm.productList = this.seckillForm.productList.concat(res.list);
			} else {
				this.$message.error("商品已存在！");
			}
			this.getStock(res.list);
		});
	}

	/**
	 * 实时保存商品价格库存
	 * @return null
	 */
	updateProduct(item) {
		const data: any = {};
		data.skgId = Number.parseInt(this.$route.params.id);
		data.skId = item.skId;
		data.skuItems = [];
		item.skuItems.forEach((el) => {
			data.skuItems.push({ sku: el.sku, price: el.price, stock: el.stock });
		});
		IPSService.secKillGroupProductEdit({ postParams: data }).then((res: any) => {
			this.$message.success("保存已生效！");
		});
	}

	/**
	 * 实时删除商品
	 * @return null
	 */
	delProduct(item) {
		const data: any = {};
		data.skgId = Number.parseInt(this.$route.params.id);
		data.skId = item.skId;
		IPSService.secKillGroupProductDel({ postParams: data }).then((res: any) => {
			this.$message.success("删除已生效！");
		});
	}

	/**
	 * 新增/编辑秒杀活动
	 * @return null
	 */
	public onSaveSeckillConfig(): void {
		this.$refs.secKillForm.validate((res) => {
			if (res) {
				// this.seckillForm.productList = this.seckillForm.productList.map(v =>{
				//   v.isOpenCommission = Number(v.isOpenCommission);
				//   return v;
				// });
				const seckillFormData = cloneDeep(this.seckillForm);
				let flag = false;
				seckillFormData.productList && (flag = seckillFormData.productList.every(this.validateIsEdit));
				if (flag) {
					this.$message.warning("当前页面存在未保存数据，请保存后再发布!");
					return false;
				}

				// 默认选中商品
				const hasDefault: number = seckillFormData.productList.findIndex((el: productItemObj) => {
					return el.isDefault == 1;
				});

				if (hasDefault === -1) {
					this.$message.error("请设置一个默认选中商品");
					return;
				}

				// 单独的图片判断
				if (seckillFormData._actShow && !seckillFormData.actImage) {
					this.$message.error("请选择图片");
					return;
				}
				if (seckillFormData._qikanShow && !seckillFormData.qikanImage) {
					this.$message.error("请选择图片");
					return;
				}
				// 未勾选，去掉展示配置的图片
				if (!seckillFormData._actShow) {
					seckillFormData.actImage = "";
				}
				if (!seckillFormData._qikanShow) {
					seckillFormData.qikanImage = "";
				}
				seckillFormData.productList.forEach((el, index) => {
					el.sort = index;
				});
				if (seckillFormData.buyConfig.type === 0) {
					seckillFormData.buyConfig.tipShow = 0;
				} else {
					if (seckillFormData._limit === 2) {
						seckillFormData.buyConfig.type = 2;
					}
				}

				seckillFormData.beforeBeginTime = moment(seckillFormData.beforeBeginTime).unix();
				seckillFormData.actBeginTime = moment(seckillFormData.actBeginTime).unix();
				seckillFormData.actEndTime = moment(seckillFormData.actEndTime).unix();

				// 版单号处理
				if (this.selectGoodsType === 2) {
					// seckillFormData.bdProductCode = seckillFormData.productList[0].bdCode;
					// seckillFormData.productList = seckillFormData.productList[0].brProducts;
				} else {
				}
				const id = this.isCopy ? "0" : this.$route.params.id;
				const loading = this.$loading({
					lock: true,
					text: "请稍等...",
					spinner: "el-icon-loading",
					background: "rgba(225,225,225,0.3)",
				});
				this.btnLoading = true;
				if (id !== "0") {
					seckillFormData.skgId = id;
				}
				if (this.isCopy) {
					seckillFormData.skgId = 0;
				}
				seckillFormData.productList.map((item) => {
					if (id == "0") {
						item.skId = 0;
					}
					if (!item.maxBuyerNum) {
						item.maxBuyerNum = 0;
					}
					if (!item.minBuyerNum) {
						item.minBuyerNum = 0;
					}
					return item;
				});
				IPSService.secKillGroupSave({ postParams: seckillFormData })
					.then((res) => {
						if (res) {
							this.$message.success(`${id === "0" ? "发布" : "编辑"}成功`);
							// this.btnLoading = false;
							// this.goBack();
							setTimeout(() => {
								this.btnLoading = false;
								this.$router.push({ path: "/seckillGroup" });
								loading.close();
								// this.goBack()
							}, 1500);
						}
					})
					.catch(() => {
						this.btnLoading = false;
						loading.close();
					});
			}
		});
	}

	/**
	 * 返回列表页
	 * @return null
	 */
	public goBack(): void {
		this.$router.go(-1);
	}

	groupInfo() {
		this.platformVersion = +localStorage.getItem("platformVersion");
	}

	/* 周期 */
	empCode = "";
	seckKillCode = "";
	public created(): void {
		this.isCopy = +this.$route.query.isCopy || 0;
		this.empCode = localStorage.getItem("empCode") || "";
		this.seckKillCode = this.$route.query.empCode as string;
		this.isOpenSkCart = +localStorage.getItem("isOpenSkCart") || 0;
		if (this.$route.params.id !== "0") {
			this.getSecKillDetail(); // 获取秒杀详情
		}
		this.groupInfo();
	}

	onDeletePic(key) {
		this.seckillForm[key] = "";
	}

	onMagnifyPic(key) {
		ImgPreview.open({ img: this.seckillForm[key] });
	}

	/**
	 * 验证是否有编辑完未保存的商品
	 */
	public validateIsEdit(val) {
		return val._edit === true;
	}

	/**
	 * 批量设置库存价格
	 */
	public batchSet() {
		if (!this.seckillForm.productList.length) {
			return false;
		}
		const data = this.seckillForm.productList.flatMap((v) => {
			return v.skuItems.map((s) => {
				return {
					productCode: v.productCode,
					sku: s.sku,
					specVal: s.specVal,
					price: s.price,
					stock: s.stock,
				};
			});
		});
		importBatchSet
			.open({
				title: "批量配置库存价格",
				fromKey: "skill",
				postParams: { skIds: this.seckillForm.productList.map((v) => v.skId) },
				empCode: this.$store.state.empCode,
				data,
				excelHeader: this.excelHeader,
			})
			.then((result) => {
				console.log(result);
				if (result.flag) {
					const updateItems = groupBy(result.result, "productCode");
					Object.keys(updateItems).forEach((e) => {
						this.seckillForm.productList = this.seckillForm.productList.map((s) => {
							if (s.productCode === e) {
								s.skuItems = s.skuItems.map((sk) => {
									const temp = updateItems[e].find((es) => es.sku === sk.sku);
									if (temp) {
										sk.price = temp.price;
										sk.stock = temp.stock;
									}
									return sk;
								});
							}
							return s;
						});
					});
					const postParams: any = {};
					postParams.skgId = Number.parseInt(this.$route.params.id);
					postParams.skuItems = [];
					this.seckillForm.productList.forEach((el) => {
						el.skuItems.forEach((ee) => {
							postParams.skuItems.push({ sku: ee.sku, price: ee.price, stock: ee.stock, productCode: el.productCode });
						});
					});
					if (+this.$route.params.id) {
						IPSService.secKillGroupProductsEdit({ postParams }).then((res: any) => {
							this.$message.success("保存已生效！");
						});
					}
				}
			}, noop);
	}
}
